import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';

@Injectable({ providedIn: 'root' })
export class NotificationService {
  constructor(private snackBar: MatSnackBar) {}

  private show(message: string, config?: MatSnackBarConfig) {
    this.snackBar.open(message, 'Fermer', {
      duration: 5000,
      horizontalPosition: 'right',
      verticalPosition: 'top',
      panelClass: ['notif-default'],
      ...config,
    });
  }

  success(message: string) {
    this.show(message, { panelClass: ['notif-success'] });
  }

  error(message: string) {
    this.show(message, { panelClass: ['notif-error'] });
  }

  info(message: string) {
    this.show(message, { panelClass: ['notif-info'] });
  }

  warning(message: string) {
    this.show(message, { panelClass: ['notif-warning'] });
  }
}
